import { useNavigate, useSearch } from "@tanstack/react-router"
import { useCallback } from "react"
import { useForm } from "react-hook-form"

import type { WarehouseFilterFormValues } from "@/screens/Warehouses/types"
import { WarehouseStatus } from "@/screens/Warehouses/types"
import { getStatusValue } from "@/utils/getStatusValue"

interface UseHandleClearFiltersReturn {
  methods: ReturnType<typeof useForm<WarehouseFilterFormValues>>
  onClear: () => void
}

export const useHandleClearFilters = (): UseHandleClearFiltersReturn => {
  const navigate = useNavigate({ from: "/app/admin/warehouses" })
  const {
    isActive,
    types = [],
    companyIds = [],
  } = useSearch({
    from: "/app/admin/warehouses/",
    strict: true,
  })

  const methods = useForm<WarehouseFilterFormValues>({
    defaultValues: {
      isActive: WarehouseStatus.Active,
      types: [],
    },
    values: {
      isActive: getStatusValue(isActive, WarehouseStatus),
      types,
      companyIds,
    },
  })

  const onClear = useCallback(() => {
    methods.reset()

    navigate({
      search: (prev: Record<string, any>) => ({
        ...prev,
        isActive: undefined,
        types: undefined,
        companyIds: undefined,
      }),
      to: "/app/admin/warehouses",
      replace: true,
    })
  }, [methods, navigate])

  return { methods, onClear }
}
